import { httpGet, httpPost, httpDelete, httpPatch } from "@/request/http";
import func from "@/funcs";

let path = "/requisitions";

export default {
  get(id) {
    return httpGet(path, { id: id });
  },
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  save(item) {
    return httpPost(path, item);
  },
  remove(id) {
    return httpDelete(path, { id: id });
  },
  done(id) {
    return httpPatch(`${path}/${id}/done`);
  },
  getFoods(dTO) {
    return httpPost(`${path}/foods/query`, dTO);
  },
  getOutOfSafeQty(warehouseId) {
    return httpGet(`/warehouses/${warehouseId}/outofsafeqty`);
  },
  getExcelByPost(foods) {
    func.getExcel.post(`${path}/exportfood`, "匯入請購單商品", foods);
  },
  postExcel(formData) {
    return func.postExcel(`${path}/importfood`, formData);
  },
};
